import {
  ATTRIBUTE_BRAND,
  ATTRIBUTE_PRODUCT_TYPE,
  ATTRIBUTE_INVENTORY,
  ATTRIBUTE_PICTURE,
  ATTRIBUTE_PRICE,
  ATTRIBUTE_TAGS,
  ATTRIBUTE_TITLE,
  VARIANT_ATTRIBUTE_TAXABLE,
  VARIANT_ATTRIBUTE_WEIGHT,
  ATTRIBUTE_PRODUCT_STATUS,
  VARIANT_ATTRIBUTE_ITEM_COST,
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION
} from "../../../../../../../../../../../constants/attributeTypes.js";
import {
  ATTRIBUTE_QUALIFIER_CONTAINS,
  ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS,
  ATTRIBUTE_QUALIFIER_HAS_NOT_TAGS,
  ATTRIBUTE_QUALIFIER_HAS_TAGS,
  ATTRIBUTE_QUALIFIER_EQUAL,
  ATTRIBUTE_QUALIFIER_IS_EMPTY,
  ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL,
  ATTRIBUTE_QUALIFIER_IS_NOT_EMPTY,
  ATTRIBUTE_QUALIFIER_IS_FALSE,
  ATTRIBUTE_QUALIFIER_IS_TRUE,
  ATTRIBUTE_QUALIFIER_LARGER,
  ATTRIBUTE_QUALIFIER_LESS,
  ATTRIBUTE_QUALIFIER_VARIANT_INVENTORY_POLICE_CONTINUE,
  ATTRIBUTE_QUALIFIER_VARIANT_INVENTORY_POLICE_DENY,
  ATTRIBUTE_QUALIFIER_SELECT_VALUE,
  ATTRIBUTE_QUALIFIER_MULTIPLE_LOCATIONS,
  ATTRIBUTE_QUALIFIER_PRODUCT_IS_NOT_ACTIVE,
  ATTRIBUTE_QUALIFIER_HAS_LOCATIONS,
  ATTRIBUTE_QUALIFIER_HAS_NOT_LOCATIONS,
} from "../../../../../../../../../../../constants/attributeQualifierTypes.js";

export const getQualifierOptions = (attribute) => {
  if (attribute === ATTRIBUTE_TITLE || attribute === ATTRIBUTE_BRAND || attribute === ATTRIBUTE_PRODUCT_TYPE) {
    return [
      { label: "Is Empty", value: ATTRIBUTE_QUALIFIER_IS_EMPTY },
      { label: "Is Not Empty", value: ATTRIBUTE_QUALIFIER_IS_NOT_EMPTY },
      { label: "Is equal to", value: ATTRIBUTE_QUALIFIER_EQUAL },
      { label: "Is not equal to", value: ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL },
      { label: "Contains", value: ATTRIBUTE_QUALIFIER_CONTAINS },
      { label: "Does Not Contain", value: ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS }
    ];
  }

  if (attribute === ATTRIBUTE_INVENTORY) {
    return [
      { label: "Is selling when out of stock", value: ATTRIBUTE_QUALIFIER_VARIANT_INVENTORY_POLICE_CONTINUE },
      { label: "Is not selling when out of stock", value: ATTRIBUTE_QUALIFIER_VARIANT_INVENTORY_POLICE_DENY },
      { label: "Is Tracked", value: ATTRIBUTE_QUALIFIER_IS_TRUE },
      { label: "Is Not Tracked", value: ATTRIBUTE_QUALIFIER_IS_FALSE },
      { label: "Is equal to", value: ATTRIBUTE_QUALIFIER_EQUAL },
      { label: "Is not equal to", value: ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL },
      { label: "Is larger than", value: ATTRIBUTE_QUALIFIER_LARGER },
      { label: "Is less than", value: ATTRIBUTE_QUALIFIER_LESS },
    ];
  }

  if (attribute === VARIANT_ATTRIBUTE_TAXABLE) {
    return [
      { label: "Is Taxable", value: ATTRIBUTE_QUALIFIER_IS_TRUE },
      { label: "Is Not Taxable", value: ATTRIBUTE_QUALIFIER_IS_FALSE },
    ];
  }

  if (attribute === ATTRIBUTE_PICTURE) {
    return [
      { label: "Is Empty", value: ATTRIBUTE_QUALIFIER_IS_EMPTY },
      { label: "Is Not Empty", value: ATTRIBUTE_QUALIFIER_IS_NOT_EMPTY }
    ];
  }

  if (attribute === ATTRIBUTE_PRICE || attribute === VARIANT_ATTRIBUTE_ITEM_COST) {
    return [
      { label: "Is equal to", value: ATTRIBUTE_QUALIFIER_EQUAL },
      { label: "Is not equal to", value: ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL },
      { label: "Is larger than", value: ATTRIBUTE_QUALIFIER_LARGER },
      { label: "Is less than", value: ATTRIBUTE_QUALIFIER_LESS },
      { label: "Contains", value: ATTRIBUTE_QUALIFIER_CONTAINS },
      { label: "Does Not Contain", value: ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS },
      { label: "Is Empty", value: ATTRIBUTE_QUALIFIER_IS_EMPTY },
      { label: "Is Not Empty", value: ATTRIBUTE_QUALIFIER_IS_NOT_EMPTY }
    ];
  }

  if (attribute === ATTRIBUTE_TAGS) {
    return [
      { label: "Has the following tag(s)", value: ATTRIBUTE_QUALIFIER_HAS_TAGS },
      { label: "Does not have the following tag(s)", value: ATTRIBUTE_QUALIFIER_HAS_NOT_TAGS },
      { label: "Contains", value: ATTRIBUTE_QUALIFIER_CONTAINS },
      { label: "Does not contain", value: ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS }
    ];
  }

  if (attribute === VARIANT_ATTRIBUTE_WEIGHT) {
    return [
      { label: "Is equal to", value: ATTRIBUTE_QUALIFIER_EQUAL },
      { label: "Is not equal to", value: ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL },
      { label: "Is larger than", value: ATTRIBUTE_QUALIFIER_LARGER },
      { label: "Is less than", value: ATTRIBUTE_QUALIFIER_LESS },
    ];
  }

  if (attribute === ATTRIBUTE_PRODUCT_STATUS) {
    return [
      { label: "Is equal to", value: ATTRIBUTE_QUALIFIER_SELECT_VALUE },
      { label: "Is not Active", value: ATTRIBUTE_QUALIFIER_PRODUCT_IS_NOT_ACTIVE },
    ];
  }

  if (attribute === VARIANT_ATTRIBUTE_INVENTORY_LOCATION) {
    return [
      { label: "Is", value: ATTRIBUTE_QUALIFIER_HAS_LOCATIONS },
      { label: "Is not", value: ATTRIBUTE_QUALIFIER_HAS_NOT_LOCATIONS },
      { label: "No locations", value: ATTRIBUTE_QUALIFIER_IS_EMPTY },
      { label: "Multiple locations", value: ATTRIBUTE_QUALIFIER_MULTIPLE_LOCATIONS },
      { label: "Locations count", value: ATTRIBUTE_QUALIFIER_EQUAL }
    ]
  }


  return [
    { label: "Is equal to", value: ATTRIBUTE_QUALIFIER_EQUAL },
    { label: "Is not equal to", value: ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL },
    { label: "Is Empty", value: ATTRIBUTE_QUALIFIER_IS_EMPTY },
    { label: "Is Not Empty", value: ATTRIBUTE_QUALIFIER_IS_NOT_EMPTY },
    { label: "Contains", value: ATTRIBUTE_QUALIFIER_CONTAINS },
    { label: "Does Not Contain", value: ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS }
  ];

};